import { render, staticRenderFns } from "./SchemaFieldSettings.vue?vue&type=template&id=29fc0715&scoped=true&"
import script from "./SchemaFieldSettings.vue?vue&type=script&lang=js&"
export * from "./SchemaFieldSettings.vue?vue&type=script&lang=js&"
import style0 from "./SchemaFieldSettings.vue?vue&type=style&index=0&id=29fc0715&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fc0715",
  null
  
)

export default component.exports